// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2-cJf","left":"InfoRow_left__1-_q_"};